import Button from '../../commons/button'
import icAddSquare from '../../../assets/images/id-add-square.svg'
import Table from '../../commons/table'
import Search from '../../commons/search'
import Toast from '../../commons/toast'
import DeleteModal from '../../commons/delete-modal'
import { TABLE_PAYROLL_NOTES } from '../../../configs/payroll/configTablePayrollNotes'
import { PayrollNotesForm } from './PayrollNotesForm'
import ViewList from 'components/commons/view-list'

export const PayrollNotes = ({
    dataList,
    isLoading,
    query,
    onChangeQuery,
    onClickItemHandler,
    onCreateNotesHandler,
    modal,
    setModal,
    formValue,
    onChangeDepartment,
    onChangeDivision,
    onChangeNotes,
    onSearchDepartment,
    onSearchDivision,
    departmentOptions,
    divisionOptions,
    isDivisionLoading,
    actionType,
    isCreating,
    isUpdating,
    isDeleting,
    isFormValid,
    onSubmitForm,
    onDelete,
    toast,
    clearToast,
    status,
}) => {
    const isSubmitted = status === 'submitted'
    const columns = isSubmitted
        ? TABLE_PAYROLL_NOTES.column
        : TABLE_PAYROLL_NOTES.column.filter((col) => col.key !== 'action')

    return (
        <div className='flex flex-col'>
            <div className='flex flex-row justify-between px-6 py-4'>
                <div className={'flex flex-row justify-between gap-3'}>
                    <Search value={query?.search} onSearch={(search) => onChangeQuery({ page: 1, search })} />
                    <ViewList
                        show={modal?.limit}
                        onShow={() => setModal((prev) => ({ ...prev, limit: true }))}
                        onClose={() => setModal((prev) => ({ ...prev, limit: false }))}
                        value={query?.limit}
                        onSelectSize={(limit) => onChangeQuery({ page: 1, limit })}
                    />
                </div>
                {isSubmitted && (
                    <Button title='Create Notes' icon={icAddSquare} onClick={onCreateNotesHandler} />
                )}
            </div>
            <Table
                className='my-3'
                name={TABLE_PAYROLL_NOTES.name}
                columns={columns}
                data={dataList?.result}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickItem={(val) => onClickItemHandler(val)}
                loading={isLoading}
            />
            <PayrollNotesForm
                show={modal?.form}
                onHide={() => setModal((prev) => ({ ...prev, form: false }))}
                title={`${actionType === 'CREATE' ? 'Create' : 'Edit'} Payroll Notes`}
                actionType={actionType}
                formValue={formValue}
                departmentOptions={departmentOptions}
                divisionOptions={divisionOptions}
                isDivisionLoading={isDivisionLoading}
                onChangeDepartment={onChangeDepartment}
                onChangeDivision={onChangeDivision}
                onChangeNotes={onChangeNotes}
                onSearchDepartment={onSearchDepartment}
                onSearchDivision={onSearchDivision}
                isFormValid={isFormValid}
                onSubmitForm={onSubmitForm}
                isLoading={isCreating || isUpdating}
            />
            <DeleteModal
                show={modal?.delete}
                onHide={() => setModal((prev) => ({ ...prev, delete: false }))}
                onDelete={onDelete}
                isLoading={isDeleting}
                text='Apakah anda yakin ingin menghapus data payroll notes?'
            />
            <Toast show={toast?.isShowToast} message={toast?.message} onClose={() => clearToast()} />
        </div>
    )
}
